import { FormLabel } from "@mui/material";
import React from "react";

const LFFormLabel = ({ ...rest }) => {
  return <FormLabel sx={{ color: "secondary.dark", fontSize: 14 }} {...rest} />;
};

export default LFFormLabel;
